import styled, { css } from "styled-components";
import { FormattedMessage } from "react-intl";
import * as PropTypes from "prop-types";

/**
 * WarningContainer
 */
const WarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.margin}rem;
  color: ${({ theme }) => theme.palette.error.main};
`;

/**
 * WarningMessages
 */
export function WarningMessages({ messages }) {
  return (
    <WarningContainer>
      {messages.map(message => {
        let key = message;
        let content = message;
        if (typeof message === "object") {
          key = message.id;
          content = <FormattedMessage {...message} />;
        }

        return <div key={key}>- {content}</div>;
      })}
    </WarningContainer>
  );
}

WarningMessages.propTypes = {
  messages: PropTypes.array.isRequired,
};

/**
 * Content
 */
export const contentWidth = ({ theme, fullWidth }) => {
  let width = null;

  if (fullWidth) {
    width = css`
      width: 100%;
    `;
  } else {
    width = css`
      ${theme.phone`
          width: 100%;
        `};
      ${theme.tabletPortraitUp`
          min-width: 450px;
        `};
    `;
  }

  return width;
};
export const Content = styled.div`
  padding: ${({ theme }) => theme.padding}rem;
  display: flex;
  flex-direction: column;

  ${contentWidth};
`;

Content.propTypes = {
  fullWidth: PropTypes.bool,
};

/**
 * FieldWrapper
 */
export const FieldWrapper = styled.div`
  margin-top: ${({ theme }) => theme.margin}rem;
  &:first-child {
    margin-top: 0;
  }
`;

/**
 * CenterHorizontal
 */
export const CenterHorizontal = styled.div`
  justify-content: center;
  display: flex;
  width: ${({ fullWidth, customWidth }) => {
    if (customWidth) {
      return `${customWidth}`;
    }
    if (fullWidth) {
      return "100%";
    }
    return "auto";
  }};
`;

CenterHorizontal.propTypes = {
  fullWidth: PropTypes.bool,
};
